const serverIO = process.env.VUE_APP_IO;
const { io } = require("socket.io-client");
import i18n from '../../i18n.js'
import router from "@/router.js";
const ver = "1";
export default {
  namespaced: true,
  state() {
    return {
      socket: null,
      loading: true,
      connected: false,
      packages: [],
    };
  },
  mutations: {
    set_package(state, { data }) {
      state.packages = data;
    },
    set_employees_null(state) {
      state.employees = null;
      state.loading = false;
    },
  },
  getters: {
    packages: (state) => state.packages,
    loading: (state) => state.loading,
    connected: (state) => state.connected
  },
  actions: {
    initSocket({ state, dispatch, commit }) {
      console.log('started to connect IO pexcode');
      if (localStorage.getItem("token"))
        state.socket = io(serverIO, {
          secure: true,//ssl
          withCredentials: false,
          path: "/qs/socket.io",
          query:
            "version=" + ver + "&authorization=" + localStorage.getItem("token"),
        });

      state.socket.on("connect", () => {
        state.connected = true;
        state.loading = false;
        $cookies.set("uuid", state.socket.id);

        // console.log(state.socket);
      });

      state.socket.on("disconnect", () => {
        state.connected = false;
        state.loading = true;
      });

      state.socket.on("close", () => {
        console.warn(
          "This session closed !!!"
        );
        alert(
          "This session closed ,try agin !!!"
        );
        state.socket.disconnect();
      });

      state.socket.on("newPackage", (data) => {
        // console.log("package", data);
        dispatch("packages/pushNewpackage", data, { root: true });
        commit(
          "alert/success",
          {
            showType: "toast",
            position: "bottom-right",
            title: "Success",
            text: i18n.t("package.alert.newpackage"),
          },
          { root: true }
        );
      });

      state.socket.on("transfer", (data) => {
        // console.log("transfer", data);
        dispatch("packages/pushNewpackage", data, { root: true });
        commit(
          "alert/success",
          {
            showType: "toast",
            position: "bottom-right",
            title: "Success",
            text: i18n.t("package.alert.newpackage"),
          },
          { root: true }
        );
      });


      state.socket.on("status", (data) => {
        // console.log("status->", data);
        var msg = "";
        if (data.status == -1) msg = i18n.t("package.status.s-1")
        else if (data.status == 0) msg = i18n.t("package.status.s0")
        else if (data.status == 1) msg = i18n.t("package.status.s1")
        else if (data.status == 3) msg = i18n.t("package.status.s3")
        else if (data.status == 2) msg = i18n.t("package.status.s2")
        else if (data.status == 4) msg = i18n.t("package.status.s4")
        else if (data.status == 5) msg = i18n.t("package.status.s5")
        else if (data.status == 6) msg = i18n.t("package.status.s6")
        else if (data.status == 7) msg = i18n.t("package.status.s7")
        else if (data.status == 8) msg = i18n.t("package.status.s8")
        else if (data.status == 9) msg = i18n.t("package.status.s9")
        else if (data.status == 10) msg = i18n.t("package.status.s10")
        else if (item.status == 14) msg = i18n.t("package.status.s14");
        else if (item.status == 15) msg = i18n.t("package.status.s15");
        else if (item.status == 16) msg = i18n.t("package.status.s16");


        commit(
          "alert/info",
          {
            showType: "toast",
            position: "bottom-right",
            title: "info",
            text: msg + data.id,
          },
          { root: true }
        );
        dispatch("packages/set_status", data, { root: true });
      });




      state.socket.on("update", (data) => {
        console.log("update", data);
      });
      state.socket.on("admin/geo", (data) => {
        dispatch("employees/trackGPS", data, { root: true });
      });
      state.socket.on("online", (data) => {
        dispatch("employees/online", data.did, { root: true });
      });
      state.socket.on("offline", (data) => {
        dispatch("employees/offline", data.did, { root: true });
      });

      state.socket.on("weclome", (data) => {
        console.log("Welcome with quick services ");
        console.log("development by pexcode");
        console.log(data.web);
        $cookies.set("pex", data.email);

        console.log(data.email);
        console.log("Call us or whatsapp", data.phone);
      });

      state.socket.on("sessionExpired", (data) => {
        console.log("sessionExpired");
        console.warn("The session was deleted !!!");
        console.log("development by pexcode");
        // commit("logout");
        dispatch("users/sessionExpired");
        dispatch(
          "error",
          {
            showType: "toast",
            text: "Session expired. Please login with your account.",
          },
          { root: true }
        );

        router.push("/login");
      });

      state.socket.on("error", (data) => console.log("error", data));
    },
  },
};
